


















































































































































import { Mixins, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import { findIndex, reduce } from 'lodash'

import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'
import Router from '@/mixins/Router'
import Date from '@/mixins/Date'
import Report from '@/mixins/Report'
import Pdf from '@/mixins/Pdf'

// Api
import { mapData, MISSION_API_MAPPING } from '@/api/Mapping'

// Components
import ScrollSpy from '@/components/behaviors/ScrollSpy.vue'
import StateTag from '@/components/common/StateTag.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'
import Box from '@/components/common/Box.vue'

// Views
import PartBox from '@/views/report/parts/PartBox.vue'
import ReportQrCode from '@/views/report/partials/ReportQrCode.vue'
import AssignReportForm from '@/views/all/forms/AssignReportForm.vue'
import FieldPhotoScan from '@/views/report/parts/fields/FieldPhotoScan.vue'
import ListAllItems from '@/views/items/partials/ListAllItems.vue'
import Gallery from '@/views/report/parts/ReportGallery.vue'
import CostingTeaser from '@/views/report/parts/CostingTeaser.vue'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
])


@Component({
  components: {
    Box,
    PartBox,
    StateTag,
    ModalWrapper,
    ScrollSpy,
    ReportQrCode,
    FieldPhotoScan,
    AssignReportForm,
    ListAllItems,
    Gallery,
    CostingTeaser
  }
})
export default class SingleReport extends Mixins(Errors, Router, Date, Report, Pdf) {
  loading: boolean = false
  showQRCodeModal: boolean = false
  showGallery: boolean = false
  clickedImageID: number = null

  report = null
  changes = []

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale
  @Action('fetchReport', { namespace: 'report' }) fetchReport
  @Getter('isFinished', { namespace: 'report' }) isFinished
  @Getter('isWaiting', { namespace: 'report' }) isWaiting
  @Getter('isReturn', { namespace: 'report' }) isReturn
  @Getter('proovCode', { namespace: 'report' }) proovCode
  @Getter('gallery', { namespace: 'report' }) gallery
  @Getter('isAdmin', { namespace: 'user' }) isAdmin

  @Getter('canShowDropoffValues', { namespace: 'report' }) canShowDropoffValues
  @Getter('canEditDropoffValues', { namespace: 'report' }) canEditDropoffValues
  @Action('updateGallery', { namespace: 'report' }) updateGallery

  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  @Watch('locale', { immediate: true })
  async updateDataWithCurrentLocale() {
    await this.fetchReportFromStore()
  }

  @Watch('gallery')
  openReportGallery() {
    this.showGallery = true
  }

  async fetchReportFromStore() {
    try {
      this.loading = true
      this.report = await this.fetchReport({ code: this.$route.params.id, locale: this.locale })
    } catch (error) {
      this.displayErrors(error)
      this.$router.push({ name: 'indexReports' })
    } finally {
      this.loading = false
    }
  }

  openQRCodeModal() {
    this.showQRCodeModal = true
  }

  openAssignReportModal() {
    this.showAssignReportModal = true
  }

  beforeRouteLeave(to, from, next) {
    if (!this.changes.length) {
      next()
      return
    }

    // @TODO - make new component, with cancel - save - unsave
    // @ts-ignore
    this.$dialog.confirm({
      title: this.$t('global.warning') as string,
      message: this.$t('global.changes') as string,
      confirmText: this.$t('global.nosave_quit') as string,
      cancelText: this.$t('global.save_quit') as string,
      type: 'is-danger',
      hasIcon: true,
      // @ts-ignore
      onCancel: async (target) => {
        if (target !== 'button') {
          return
        }
        await this.saveReport()
        this.$toast.open({
          message: this.$t('global.saved') as string,
          type: 'is-success',
          duration: 5000
        })
        next()
      },
      onConfirm: () => {
        next()
      }
    })
  }

  // Getters
  get processRequired() {
    return this.report.process.filter((item) => item.required)
  }

  get processNotRequired() {
    return this.report.process.filter((item) => !item.required)
  }

  get processWithImages() {
    return this.report.process.filter((item) => item.hasImages)
  }

  get galleryParts() {
    const parts = this.report.parts.filter((part) => part.supports.length > 0)
    const sections = reduce(parts, (result, part, key) => {
      result.push({
        id: part.id,
        title: part.title,
        photos: part.supports
      })
      return result
    }, [])

    sections.push({
      id: 'photo-scan',
      title: this.$t('report.edit.header.part.photo_scan'),
      photos: this.report.process
    })
    return sections
  }

  async updateParts() {
    try {
      this.loading = true
      await this.$api.reports.updateReportParts(this.token, this.report.proovCode, this.changes)
      this.changes = []
      await this.fetchReportFromStore()
      this.$toast.open({
        message: this.$t('global.saved') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  updateChange(newField) {
    const index = findIndex(this.changes, (field) => field.id === newField.id)
    if (index !== -1) {
      this.changes[index] = newField
    } else {
      this.changes.push(newField)
    }
  }

  async saveReport() {
    await this.updateParts()
  }

  async deleteReport() {
    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('report.actions.delete.message') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          const res = await this.$api.reports.deleteReport(this.token, this.report.proovCode)
          this.$router.push({ name: 'indexReports' })
          this.$toast.open({
            message: this.$t('reports.actions.delete.success.title') as string,
            type: 'is-success',
            duration: 5000
          })
        } catch (error) {
          this.displayErrors(error)
        }
      }
    })
  }

  async assignReport(first, formData) {
    try {
      const data = {...formData, proovCode: this.proovCode, reportState: 'pending_first' }
      if (this.isReturn && first) {
        data.reportState = 'pending_second'
      }
      await this.$api.missions.createMission(this.token, mapData(MISSION_API_MAPPING, data, true, false))
      this.showAssignReportModal = false
      this.$toast.open({
        message: this.$t('global.info_box.create_success_content') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    }
  }

  openPhotoOnGallery(field, partID) {
    this.updateGallery({
      partID: partID.toString(),
      photoID: field.id
    })
  }
}
